import React from 'react';
import AppRouter from './routes/AppRouter';
import IndustrySelectionModal from './components/Auth/IndustrySelectionModal';
import { ModuleVisibilityProvider } from './contexts/ModuleVisibilityContext';
import useBackgroundSpeedTest from './hooks/useBackgroundSpeedTest';
import './App.css';

function App() {
  // Mounted once at the app root so automatic network speed sampling keeps
  // running for the whole session regardless of which page is open.
  useBackgroundSpeedTest();

  return (
    <ModuleVisibilityProvider>
      <AppRouter />
      <IndustrySelectionModal />
    </ModuleVisibilityProvider>
  );
}

export default App;
